export default __webpack_public_path__ + "static/univers-rounded-black-50fd50bfc0c1d455540c3fe41dea0454.woff2";